import React, { useContext } from 'react';
import View from '../component/View';
import apiService from '../../../../../apiService';
import { AdminContext } from '../../index';

const VerifikasiHotel = ({ data, backHome }) => {
  const { setContextData } = useContext(AdminContext);
  const handleSubmit = async (
    { status, keterangan, index },
    callBack = () => {}
  ) => {
    const params = {
      persyaratan_id: data.persyaratan[ index ].persyaratan_id,
      hotel_registration_id: data.id,
      verified: status,
      keterangan: keterangan,
    };
    const result = await apiService.put('/hotel/registration/verify', params);
    if (result.code === 200) callBack(status);
  };

  const setTanggalKunjungan = async (
    { date, name = '', reason = '' },
    callBack
  ) => {
    const params = {
      registration_id: data.id,
      editor_id: JSON.parse(localStorage.getItem('userData')).id,
      nama: name,
      alasan: reason,
      visit_date: date,
    };
    const result = await apiService.post(
      '/hotel/registration/visit_date',
      params
    );
    if (result.code === 200) {
      setContextData({ tanggalKunjungan: date });
      callBack();
    }
  };

  return (
    <View
      data={ data.persyaratan ? data.persyaratan : [] }
      handleSubmit={ handleSubmit }
      setTanggalKunjungan={ setTanggalKunjungan }
    />
  );
};

export default VerifikasiHotel;
